import { put, takeEvery } from 'redux-saga/effects';
import { push, go } from 'react-router-redux';
import { LOGIN } from './constants';
import { requestToken } from './api';
import { login_success } from './actions';
import { setCookie } from '../../utils/cookieService';
import { lSsetCookie } from '../../utils/lstorageService';
import { passportKey, clientId } from '../../constants/routes';

function* login( actionObject ) {

    const requestBody = {
        ...actionObject.form,
        client_id: clientId,
        client_secret: passportKey,
        scope: '',
        grant_type: 'password'
    };


    const token = yield requestToken( requestBody );

    if ( token ) {
        if ( token && token.error ) {
            yield put( login_success( { error: true, message: token.message ?? 'The user credentials were incorrect.' } ) )
        } else {
            yield onLoginSuccess( token );
            yield put( login_success( { error: false, message: 'Authorized' } ) );
            yield put( push( '/dashboard/quizes' ) );
            yield put( go( '/dashboard/quizes' ) );
        }
    }
}

/**
 *
 * @param tokenData
 */
const onLoginSuccess = tokenData => {
    setCookie( 'token', tokenData.access_token, 1 );
    setCookie( 'refreshToken', tokenData.refresh_token, 1 );
    lSsetCookie( 'token', tokenData.access_token );
    lSsetCookie( 'refreshToken', tokenData.refresh_token );
};

function* watchLogin() {
    yield takeEvery( LOGIN, login );
}

export default watchLogin;
